import { initializeOwaConnectedAccount } from '../utils/initializeOwaConnectedAccount';
import { getOWAConnectedAccount } from 'owa-accounts-store';
import { triggerReInitializeAccount } from 'owa-headers-refresh-token';
import { orchestrator } from 'satcheljs';
import { OwaConnectedAccountInitSource } from '../schema/OwaConnectedAccountInitSource';

/**
 * This orchestrator is triggered from owa-connected-account-headers after it has fixed the token for the account
 */
orchestrator(triggerReInitializeAccount, actionMessage => {
    const account = getOWAConnectedAccount(actionMessage.userIdentity);
    initializeOwaConnectedAccount(account, OwaConnectedAccountInitSource.Init, true);
});
